module.exports = __webpack_public_path__ + "img/virgin-money-logo.611ef785.svg";